export type OrgKey = 'bomet' | 'nyandarua' | 'baringo' | 'lims';
type OrgMeta = { key: OrgKey; name: string; logo?: string; favicon?: string };

const META: Record<OrgKey, OrgMeta> = {
  bomet: { key: 'bomet', name: 'Bomet', logo: '/bomet/logo.svg', favicon: '/bomet/favicon-128.png' },
  nyandarua: { key: 'nyandarua', name: 'Nyandarua', logo: '/nyandarua/logo.webp', favicon: '/nyandarua/favicon-128.png' },
  baringo: { key: 'baringo', name: 'Baringo', logo: '/baringo/logo.svg', favicon: '/baringo/favicon-128.png' },
  lims: { key: 'lims', name: 'LIMS', logo: '/lims/logo.png', favicon: '/lims/favicon-64.png' },
};

export function getOrgMetaClient(org?: string): OrgMeta {
  const k = (org || '').toLowerCase().trim() as OrgKey;
  return META[k] || META.bomet;
}
